// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OR6tJfhbhxYjcYz1aQ0U{width:100%;max-width:620px;margin:0 auto;padding:0 20px 92px}@media (min-width:992px){.OR6tJfhbhxYjcYz1aQ0U{max-width:760px}}.qwJZfeXNgC0S8VBaWOuR{overflow-x:hidden;overflow-y:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `OR6tJfhbhxYjcYz1aQ0U`,
	"wrap": `qwJZfeXNgC0S8VBaWOuR`
};
export default ___CSS_LOADER_EXPORT___;
